module.exports = __webpack_public_path__ + "img/second_.dfd48f87.jpg";